// Normalize CSS StyleSheet
import './assets/css/reset-normalize.css';
// Main Stylesheet
import './assets/css/index.css';
import './assets/css/pagination.css';
// Grid CSS
import './assets/css/simple-grid.css';
// Import all other css files here to prevent webpack writing inline styles to <head>
import './components/NotificationsSystem/notifications.css';
// BuyPower Icon Fonts
import './assets/css/buypower-icon-fonts-v1.css';
// Print CSS
import './assets/css/print.css';
// React day picker library
import 'react-day-picker/lib/style.css';

import { BrowserRouter, Route, Switch } from 'react-router-dom';
import React, { Component, Fragment } from 'react';

import A from './analytics';
import ContactService from './components/ContactService';
import { ContentPages } from './views/StaticPages';
import ErrorFallback from './ErrorFallBackComponent';
import Footer from './components/Footer';
import FounderFriday from './components/FounderFriday';
import HomeNav from './components/HomeNav';
import LiveChat from './components/LiveChat';
import Loading from './components/Loading';
import PasswordReset from './views/PasswordReset';
import { PersistGate } from 'redux-persist/es/integration/react';
import { Provider } from 'react-redux';
import StartSession from './components/StartSession';
import StaticPages from './views/StaticPages';
import SupportForm from './components/SupportForm';
import UtilsComponent from './components/UtilsComponent';
import { callApi } from './utils';
import initStore from './store';
import loadComponent from './HOC/loadComponent';
import { updateExperiments } from './actions/experimentActions';
import { updateSettings } from './actions/settingsActions';


const MainPages = loadComponent(() => import('./views/MainPages'), {
  Loading,
  preload: true,
  delay: 5000,
});

const Layout = loadComponent(() => import('./views/Layout'), {
  Loading,
  preload: true,
  delay: 5000,
});

const BrandPressKit = loadComponent(() => import('./views/BrandPressKit'), {
  Loading,
  preload: true,
  delay: 5000,
});

const Notifications = loadComponent(() => import('./components/Notifications'), {
  reloadOnFailed: false,
});

const Modals = loadComponent(() => import('./components/Modals'), {
  reloadOnFailed: false,
});

const Popups = loadComponent(() => import('./components/Popups'), {
  reloadOnFailed: false,
});

// Initialize Redux Store
const { store, persistor } = initStore();

class App extends Component {
  state = {
    error: '',
    errorInfo: '',
    hasError: false,
    pathname: window.location.pathname,
    showFooter: false,
  };

  componentDidCatch = (err, errorInfo) => {
    A.logError(err.message, true);
    // window.location.reload();
    this.setState({ error: err, hasError: true, errorInfo });
  };

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }


  componentDidUpdate(prevProps, prevState) {
    // Check if the location has changed
    console.log('component changed')
    if (window.location.pathname !== this.state.pathname) {
      this.toggleFooterVisibility();
    }
  }

  toggleFooterVisibility = () => {
    const { pathname } = window.location;
    const hidePaths = ["/", "/auth", "/login", "/register", "/merchant"];
    const showFooter = !hidePaths.includes(pathname);
    this.setState({ showFooter });
  };

  componentDidMount() {
    this.loadSettings();
    this.loadExperiments();
    this.toggleFooterVisibility();
  }

  loadSettings() {
    callApi('/settings')
      .then(({ data = {} }) => {
        store.dispatch(updateSettings(data));
      })
      .catch(console.error);
  }

  loadExperiments() {
    callApi('/experiment/downloadapp')
      .then((data = {}) => {
        const state = store.getState();
        if (!state.experiments.mobileDownload.executed)
          store.dispatch(updateExperiments({ mobileDownload: data }));
      })
      .catch(() => { });
  }

  render() {
    const { hasError, errorInfo, error, showFooter } = this.state;
    if (hasError) {
      return <ErrorFallback error={error} errorInfo={errorInfo} />;
    }
    return (
      <Provider store={store}>
        <PersistGate persistor={persistor} loading={<Loading />}>
          <BrowserRouter>
            <Fragment>
              <UtilsComponent />
              <div className='app'>
                <Switch>
                  <Route
                    path='(/|/auth|/login|/register|/forgot|/merchant|/disco|/discos)'
                    component={Layout}
                  />
                  <Route exact path='/reset/:token' component={PasswordReset} />
                  {/* Add legacy routes */}
                  <Route
                    path='/review/testimonials'
                    component={() => {
                      window.location = 'https://mini.buypower.ng/review/testimonials';
                      return null;
                    }}
                  />
                  <Route path='/content/merchants/tnc' component={ContentPages} />
                  <Route
                    path='/contact'
                    component={() => {
                      return (
                        <div className='home-page'>
                          <HomeNav />

                          <div>
                            <div className='banner bg-img'>
                              <div className='contain' />
                            </div>
                          </div>
                          <div style={{ marginTop: '30px' }}>
                            <div
                              className='payment-box login-box'
                              style={{ backgroundColor: 'rgb(255, 255, 255)' }}
                            >
                              <div className='header'>
                                <h3>Contact Us</h3>
                              </div>
                              <div className='content' style={{ display: 'flex' }}>
                                <SupportForm home={true} />
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    }}
                  />
                  <Route path='/content/disco/kct' component={ContentPages} />
                  <Route path='/faq' component={StaticPages} />
                  <Route path="/media-kit" component={BrandPressKit} />
                  <Route path='/about' component={ContentPages} />
                  <Route exact path='/conversations' component={ContactService} />
                  <Route exact path='/conversations/livechat' component={LiveChat} />
                  <Route exact path='/foundersfriday' component={FounderFriday} />
                  <Route exact path='/privacy-policy' component={StaticPages} />
                  <Route exact path='/terms-of-use' component={StaticPages} />
                  <Route exact path='/payment-authorization-result' component={StaticPages} />
                  <Route exact path='/start-session' component={StartSession} />
                  <Route component={MainPages} />
                </Switch>
                {/* <StickyFooter /> */}
              </div>
              {showFooter ? <Footer /> : <Fragment></Fragment>}
            </Fragment>
          </BrowserRouter>
          <Notifications />
          <Modals />
          <Popups />
        </PersistGate>
      </Provider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js